<template>
  <div class="relative">
    <p
      v-if="products[productId]"
      class="absolute bottom-0 m-4 flex rounded-xs bg-black p-2 text-sm c-white fw-700 uppercase"
    >
      <base-picture v-bind="icon" :alt="$t.model3d" class="mr-2" />
      {{ $t.model3d }}
    </p>
    <iframe
      v-show="products[productId] === hash"
      v-for="(hash, key) in hashes"
      :key
      ref="iframes"
      v-style="{ 'aspect-ratio': { sm: '1/1', md: '21/9' } }"
      allow="autoplay; fullscreen; xr-spatial-tracking"

      allowfullscreen
      class="mb-4 w-full"
      mozallowfullscreen="true"

      :title="$t.model3d"
      web-share
      webkitallowfullscreen="true"
      xr-spatial-tracking
    />
  </div>
</template>

<script lang="ts" setup>
const { productId } = defineProps<{
  productId: string
}>()

const { products, autoplay, icon } = useAppConfig().components.sketchfab
const iframes = ref()
const hashes = ref<string[]>([])
const apis: any[] = []
const { $t } = useNuxtApp()

watch(() => iframes.value.length, () => {
  // Catch the iframe added to the dom
  const sketchfab = new window.Sketchfab(iframes.value.at(-1))
  sketchfab.init(products[productId], {
    ui_controls: 0,
    ui_infos: 0,
    ui_watermark: 0,
    success: (api) => {
      apis.push(api)
      if (autoplay)
        api.start()
    },
    error: (e: any) => log.error(`Sketchfab: Error initializing viewer:`, e)
  })
})

const { onLoaded } = useScript({
  async: true,
  integrity: 'sha256-L6xxMyYXO8vGH5p6/VjlsU5jv+qFXczZKPd3oFZ3xGQ=',
  src: 'https://static.sketchfab.com/api/sketchfab-viewer-1.12.1.js'
})

onLoaded(() => {
  watchImmediate(() => productId, () => {
    const hash = products[productId]
    const hashIndex = hashes.value.indexOf(hash)
    // Play / Pause rendering processes according to the iframe that need to be displayed
    apis.forEach((api, i) => i === hashIndex ? autoplay && api.start() : api.stop())
    // Is the SKU available within JSON file ?
    if (!hash) return
    // Create a new iframe if the viewer has not yet loaded
    if (hashIndex === -1) hashes.value.push(hash)
  })
})
</script>
